import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { nlMessages } from "@/i18n/nl";
import { palmtreeUiMessages } from "@/i18n/nl/palmtree";
import { nlSearchMessages } from "@/i18n/nl/search";
import { englishCrmMessages } from "./englishCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

/** English catalog for unit tests. The app itself only loads nl. */
const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
  nlSearchMessages,
  palmtreeUiMessages,
);

export const getInitialLocale = (): "nl" => {
  return "nl";
};

// nl is the only active locale, and there is no language switcher.
// To add a language later: copy src/i18n/nl to src/i18n/<locale>, translate
// those files, import the catalog here, and add it to the locales list.
export const i18nProvider = polyglotI18nProvider(
  () => nlMessages,
  getInitialLocale(),
  [{ locale: "nl", name: "Nederlands" }],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
